export const experienceData = [
    {
        id: 1,
        company: 'Infinite Computer Solutions',
        jobtitle: 'Java Developer',
        startYear: '2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Goibibo / MakeMyTrip',
        jobtitle: 'Frontend Developer',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 3,
        company: 'Entropy Box',
        jobtitle: 'Unity3D Game developer',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 4,
        company: 'Tech Mahindra',
        jobtitle: 'Software Engineer',
        startYear: '2014',
        endYear: '2017'
    },
]